<script>
import { storeToRefs } from 'pinia';
import SelectProperty from './SelectProperty.vue';
import ProgressIndicator from './ProgressIndicator.vue';
import PersonalDetails from './PersonalDetails.vue';
import DocumentUpload from './DocumentUpload.vue';
import Navigator from './Navigator.vue';
import Summary from './Summary.vue';
import SubmitForm from './SubmitForm.vue';
import { useReservationStore } from '../../../store/contact/ReservationStore';

export default {
    setup() {
        const store = useReservationStore();
        const { setEstateList } = store;
        setEstateList();
        const { totalSteps, currentStep } = storeToRefs(store);
        return {
            totalSteps,
            currentStep,
        };
    },
    components: {
        SelectProperty,
        ProgressIndicator,
        PersonalDetails,
        DocumentUpload,
        Navigator,
        Summary,
        SubmitForm,
    },
};
</script>
<template>
    <div class="contact-reserve">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h1
                        class="fs-32px fs-40px-xl fw-regular tw-text-darkGreen mb-24px lh-1"
                    >
                        Want to reserve a property? Tell us more.
                    </h1>
                    <ProgressIndicator></ProgressIndicator>
                    <div class="form-content mt-30px">
                        <div>
                            <span
                                class="d-none d-lg-block steps-count fs-16px tw-text-darkGreen text-uppercase fw-semibold mt-64px-lg"
                            >
                                Step {{ currentStep }} of {{ totalSteps }}</span
                            >
                            <SelectProperty
                                v-if="currentStep == 1"
                            ></SelectProperty>
                            <PersonalDetails
                                v-if="currentStep == 2"
                            ></PersonalDetails>
                            <DocumentUpload
                                v-if="currentStep == 3"
                            ></DocumentUpload>
                        </div>
                    </div>
                </div>
            </div>
            <Navigator v-if="currentStep < totalSteps"></Navigator>
            <Summary v-if="currentStep == totalSteps"></Summary>
            <SubmitForm v-if="currentStep == totalSteps"></SubmitForm>
        </div>
    </div>
</template>
